import React from 'react';
import clsx from 'clsx';
import {useStyles} from './helper'
import { useDispatch } from 'react-redux';
import { postUpdateStatus } from '../../store/api/postUpdateStatus';

const GameItem = ({item}) => {
    const {uuid, name, provider, status} = item;
    const [statusGame, setStatusGame] = React.useState(status);
    const classes = useStyles();
    const dispatch = useDispatch();

    return (
        <div className={classes.root}>
            <div className={classes.wrap}>
                <span className={classes.helper}>ID игры:</span>
                <span className={classes.description}>
                    {uuid}
                </span>
            </div>
            <div className={classes.wrapBlockDescription}>
                <div className={classes.w50}>
                    <div className={classes.wrap}>
                        <span className={clsx(classes.helper, classes.fs)}>Название игры:</span>
                        <span className={classes.wrapBlockDescription}>
                            {name}
                        </span>
                    </div>
                </div>
                <div className={classes.w50}>
                    <div className={classes.wrap}>
                        <span className={clsx(classes.helper, classes.fs)}>Провайдер:</span>
                        <span className={classes.description}>
                            {provider}
                        </span>
                    </div>
                </div>
            </div>
            <div className={classes.wrapBtn}>
                <span 
                    className={classes.btn}
                    onClick={() => {
                        dispatch(postUpdateStatus({
                            status: !statusGame,
                            uuid
                        }))
                        setStatusGame(!statusGame);
                    }}
                >
                    {statusGame ? 'Отключить' : 'Включить'}
                </span>
            </div>
        </div>
    )
}

export default GameItem;